module.exports = __webpack_public_path__ + "img/sign-up-img-1.36bf61c.png";